export const PRICING = {
    symposium: [
        { label: 'Other Specialist', price: 3000000 },
        { label: 'IHA Member', price: 2500000 },
        { label: 'GP / Allied Professional / Nurse', price: 1000000 },
    ],
    workshop: [
        { label: 'Full day workshop', price: 3000000 },
        { label: 'Half day workshop', price: 1500000 },
        { label: 'Special workshop for nurse', price: 2000000 },
    ],
    packages: [
        {
            name: 'Wingko Package',
            description: 'Symposium + 1 Half day workshop',
            prices: [
                { label: 'GP / Allied Professional', price: 1750000 },
                { label: 'IHA Members', price: 3500000 },
                { label: 'Other Specialist', price: 3800000 },
            ],
        },
        {
            name: 'Lumpia Package',
            description: 'Symposium + 1 Full day workshop',
            prices: [
                { label: 'GP / Allied Professional', price: 2750000 },
                { label: 'IHA Members', price: 4000000 },
                { label: 'Other Specialist', price: 5000000 },
            ],
        },
        {
            name: 'Bandeng Presto Package',
            description:
                'Symposium + 1 Full day workshop + 1 Half day workshop',
            prices: [
                { label: 'GP / Allied Professional', price: 3800000 },
                { label: 'IHA Members', price: 5000000 },
                { label: 'Other Specialist', price: 6000000 },
            ],
        },
    ],
};
